import ErrorMixin from "@/mixins/errors.mixin"
import {UsersService} from "@/app/exercise/modules/users/core/users-service";

export const UserTabMixin = {
  components: {
    list: () => import('@/app/exercise/components/ItemsList'),
  },

  mixins: [ErrorMixin],

  data() {
    return {
      svc: null,
      list: [],
      listLoading: false,
      pagination: null,
      headers: [],
    };
  },
  async mounted() {
    const {id: user} = this.$route.params;

    this.pagination = {
      page: 1,
      user
    };

    this.loadInfo();
  },

  methods: {
    async loadInfo() {
      try {
        this.listLoading = true;
        let { results, pagination } = await this.loadFromApi(this.pagination);
        this.pagination = {
          ...this.pagination,
          ...pagination
        };
        this.list = results;
        this.listLoading = false;
      } catch (error) {
        this.listLoading = false;
        this.processError(error, {redirectName: this.$ROUTER_NAMES.LOGIN_EXERCISE});
      }
    },


    async loadListMore(page) {
      try {
        this.listLoading = true;
        this.pagination.page = page;
        let { results } = await this.loadFromApi(this.pagination);
        this.list.push(...results);
        this.listLoading = false;
      } catch (error) {
        this.listLoading = false;
        this.processError(error, {redirectName: this.$ROUTER_NAMES.LOGIN_EXERCISE});
      }
    },
  }

};
